const notificationTypes = {
	more_info: 'weitere Informationen',

	note_text: 'Notiz',
	note_title: 'Neue Notiz',

	lostpassword_text: 'Passwortanfrage',
	lostpassword_title: 'Passwortanfrage gesendet an',

	welcome_text: 'Begrüßungsemail',
	welcome_title: 'Begrüßungsemail versendet an',

	message_text: 'Nachricht erhalten',
	message_title: 'Nachricht erhalten von',

	messagedone_text: 'Nachricht bearbeitet',
	messagedone_title: 'Nachricht bearbeitet',
	messagedone_name: '@:notificationTypes.more_info',

	damagereport_text: 'Schadensmeldung',
	damagereport_title: 'Schadensmeldung erhalten von',

	meterleveldaily_text: 'Freizugebene Zählerstande',
	meterleveldaily_title: 'Freizugebene Zählerstande',
	meterleveldaily_name: 'klicken Sie hier um diese freizugeben',

	documentuser_text: 'Neue Dokumente',
	documentuser_title: 'Neue Dokumente',
	documentuser_name: 'Dokumente anzeigen',

	syncstatus_text: 'Datenaktualisierung',
	syncstatus_title: 'Daten wurden aktualisiert',
	syncstatus_name: '@.capitalize:notificationTypes.more_info',

	quotaexceeded_text: 'Speicherplatzlimit überschritten',
	quotaexceeded_title: 'Max. Speicherplatz erreicht oder überschritten',
	quotaexceeded_name: 'Erweiterung anfragen',

	meterlevelrejected_text: 'Zählerstand abgelehnt',
	meterlevelrejected_title: 'Zählerstand abgelehnt',

	handoverinvitation_text: 'Übergabeprotokolleinladung',
	handoverinvitation_title: 'Einladung zu einer Übergabe',
	handoverinvitation_name: 'Bitte überprüfen Sie Ihre E-Mails',

	personupdate_text: 'Datenänderungsantrag liegt vor',
	personupdate_title: 'Datenänderungsanfrage gesendet',
	personupdate_name: 'Zum Konto',

	personupdateadmin_text: 'Datenänderungsantrag angelegt',
	personupdateadmin_title: 'Neue Datenänderungsanfrage',
	personupdateadmin_name: 'Antrag bearbeiten',

	consumptionnotification_text: 'Neue Verbrauchsinformationen',
	consumptionnotification_title: 'Neue Verbrauchsinformationen',
	consumptionnotification_name: 'Verbrauchsinformationen anzeigen',

	privacytosrejected_text: 'Nutzungsbedingungen abgelehnt',
	privacytosrejected_title: 'Nutzungsbedingungen abgelehnt',
	privacytosrejected_name: '@:notificationTypes.more_info',

	tickethistory_text: 'Es sind Datenänderungen zu Ihrem Ticket vorhanden ',
	tickethistory_title: 'Es sind Datenänderungen zu Ihrem Ticket vorhanden ',
	tickethistory_name: '@:notificationTypes.more_info',

	reviewdocument_title: 'Belegprüfung',
	reviewdocument_name: '@:notificationTypes.more_info',

	reportnotification_title: 'Meldung',
	reportnotification_text: 'Es sind Datenänderungen zu Ihrer Meldung vorhanden',
}

export default notificationTypes
